import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import AdjustUserCreditsForm from './AdjustUserCreditsForm';

const UserCreditsTable = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const res = await api.get('/api/credit-log');
        setTransactions(res.data);
      } catch (err) {
        console.error('Error al cargar transacciones:', err);
        setError('❌ Error al cargar transacciones');
      } finally {
        setLoading(false);
      }
    };
    fetchTransactions();
  }, []);

  return (
    <div className="bg-[oklch(97%_0.014_254.604)] min-h-screen py-8 px-4 sm:px-6 lg:px-8 font-[Manrope]">
      <div className="mx-auto max-w-7xl">
        <div className="bg-white shadow-md rounded-xl p-6">
          <div className="sm:flex sm:items-center sm:justify-between mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-gray-900">Movimientos de Crédito</h1>
              <p className="mt-1 text-sm text-gray-600">
                Historial general de créditos y ajustes realizados a todos los usuarios.
              </p>
            </div>
            <div className="mt-4 sm:mt-0">
              <button
                onClick={() => setShowModal(true)}
                className="inline-flex items-center rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm bg-[oklch(54.6%_0.245_262.881)] hover:bg-[oklch(54.6%_0.245_262.881)]"
              >
                + Ajustar Créditos
              </button>
            </div>
          </div>

          {loading ? (
            <p className="text-gray-500">Cargando...</p>
          ) : error ? (
            <p className="text-red-600">{error}</p>
          ) : transactions.length === 0 ? (
            <div className="text-center py-12">
              <svg
                className="mx-auto h-12 w-12 text-gray-400"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h3 className="mt-2 text-sm font-semibold text-gray-900">
                Sin registros de crédito
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                Aún no se han registrado movimientos.
              </p>
            </div>
          ) : (
            <>
              <div className="overflow-x-auto lg:block hidden">
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                  <thead className="bg-gray-50 text-left text-xs font-semibold text-gray-600">
                    <tr>
                      <th className="px-4 py-2">Fecha</th>
                      <th className="px-4 py-2">Usuario</th>
                      <th className="px-4 py-2">Saldo Anterior</th>
                      <th className="px-4 py-2">Monto</th>
                      <th className="px-4 py-2">Nuevo Saldo</th>
                      <th className="px-4 py-2">Motivo</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 bg-white">
                    {transactions.map((tx) => (
                      <tr key={tx.id} className="hover:bg-gray-50">
                        <td className="px-4 py-2">{new Date(tx.created_at).toLocaleString()}</td>
                        <td className="px-4 py-2">
                          {tx.first_name} {tx.last_name}
                          <br />
                          <span className="text-xs text-gray-500">{tx.email}</span>
                        </td>
                        <td className="px-4 py-2">{Number(tx.previous_balance).toFixed(2)}</td>
                        <td className="px-4 py-2">{Number(tx.amount_added).toFixed(2)}</td>
                        <td className="px-4 py-2">{Number(tx.new_balance).toFixed(2)}</td>
                        <td className="px-4 py-2">{tx.note || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="lg:hidden space-y-4">
                {transactions.map((tx) => (
                  <div
                    key={tx.id}
                    className="bg-white border border-gray-200 rounded-lg shadow-sm p-3 flex flex-col items-start gap-2"
                    role="article"
                    aria-labelledby={`transaction-${tx.id}`}
                  >
                    <div className="flex items-center w-full justify-between">
                      <h2 id={`transaction-${tx.id}`} className="font-medium text-gray-900 text-sm">
                        {tx.first_name} {tx.last_name}
                      </h2>
                      <span className="text-xs text-gray-500">{new Date(tx.created_at).toLocaleTimeString()}</span>
                    </div>
                    <p className="text-xs text-gray-500">Email: {tx.email}</p>
                    <div className="grid grid-cols-2 gap-2 w-full">
                      <p className="text-sm">Saldo Ant.: {Number(tx.previous_balance).toFixed(2)}</p>
                      <p className="text-sm">Monto: {Number(tx.amount_added).toFixed(2)}</p>
                      <p className="text-sm">Nuevo Saldo: {Number(tx.new_balance).toFixed(2)}</p>
                      <p className="text-sm">Fecha: {new Date(tx.created_at).toLocaleDateString()}</p>
                    </div>
                    <p className="text-sm">Motivo: {tx.note || '-'}</p>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6 relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-xl"
            >
              ✕
            </button>
            <AdjustUserCreditsForm />
          </div>
        </div>
      )}
    </div>
  );
};

export default UserCreditsTable;